"use strict";
/**
 * Copyright © 2021 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeOptions = void 0;
const material_1 = require("@mui/material");
const default_fonts_1 = require("../default-fonts");
const color_palette_1 = require("./color-palette");
const component_overrides_1 = require("./component-overrides");
const typography_1 = require("./typography");
/**
 * This theme is universally used within all user-facing Vamstar products.
 * 100 - Darker, 200 - Dark, 400 - Light, Lighter - 500, Lightest - 600, main - main color of palette
 * Success object is same as tertiary
 * Error object is same as reds
 * Warning object is same as yellows
 * Info object is same as secondary
 */
exports.themeOptions = material_1.createTheme({
    palette: color_palette_1.ColorPaletteConfig,
    typography: typography_1.TypographyConfig,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    spacing: 8,
    components: Object.assign({ MuiCssBaseline: {
            styleOverrides: default_fonts_1.sourceSansPro,
        } }, component_overrides_1.ComponentOverrideConfig),
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUtb3B0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb25zdGFudHMvdGhlbWUvdGhlbWUtb3B0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSCw0Q0FBNEM7QUFFNUMsb0RBQWlEO0FBQ2pELG1EQUFxRDtBQUNyRCwrREFBZ0U7QUFDaEUsNkNBQWdEO0FBRWhEOzs7Ozs7O0dBT0c7QUFDVSxRQUFBLFlBQVksR0FBRyxzQkFBVyxDQUFDO0lBQ3RDLE9BQU8sRUFBRSxrQ0FBa0I7SUFDM0IsVUFBVSxFQUFFLDZCQUFnQjtJQUM1QixXQUFXLEVBQUU7UUFDWCxNQUFNLEVBQUU7WUFDTixFQUFFLEVBQUUsQ0FBQztZQUNMLEVBQUUsRUFBRSxHQUFHO1lBQ1AsRUFBRSxFQUFFLEdBQUc7WUFDUCxFQUFFLEVBQUUsSUFBSTtZQUNSLEVBQUUsRUFBRSxJQUFJO1NBQ1Q7S0FDRjtJQUNELE9BQU8sRUFBRSxDQUFDO0lBQ1YsVUFBVSxrQkFDUixjQUFjLEVBQUU7WUFDZCxjQUFjLEVBQUUsNkJBQWE7U0FDOUIsSUFDRSw2Q0FBdUIsQ0FDM0I7Q0FDRixDQUFDLENBQUMifQ==